import { render, staticRenderFns } from "./TheFreeProducts.vue?vue&type=template&id=7839eecb&"
import script from "./TheFreeProducts.vue?vue&type=script&lang=js&"
export * from "./TheFreeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7839eecb')) {
      api.createRecord('7839eecb', component.options)
    } else {
      api.reload('7839eecb', component.options)
    }
    module.hot.accept("./TheFreeProducts.vue?vue&type=template&id=7839eecb&", function () {
      api.rerender('7839eecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/pages/marketing_item/TheFreeProducts.vue"
export default component.exports